import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_ALL_PLAN_WORKS].GET_REGULATIONS_ALL_PLAN_WORKS]: {
		url:'/company/:companyId/regulations/:regulationId/all_plan_works/',
	}
}